import config from '@/config'
import { main } from '@caterdesk/ui--theme'

export const loggedInLinks = [
  {
    name: 'My dashboard',
    url: '/dashboard',
    icon: 'Dashboard' as const,
  },
  {
    name: 'Try Canteen?',
    url: config.URI_CANTEEN,
    icon: 'LocalDining' as const,
  },
  {
    name: 'Log out',
    url: '/authentication/logout',
    color: main.colors.error,
    icon: 'Logout' as const,
  },
]

export const getLoggedInManagerLinks = (sidebarNavEnabled: boolean) => [
  {
    name: 'My dashboard',
    url: '/dashboard',
    icon: 'Dashboard' as const,
  },
  ...(!sidebarNavEnabled
    ? [
        {
          name: 'Admin dashboard',
          url: `${config.URI_CANTEEN}/ca`,
          icon: 'ManageAccounts' as const,
        },
      ]
    : []),
  {
    name: 'Try Canteen?',
    url: config.URI_CANTEEN,
    icon: 'LocalDining' as const,
  },
  {
    name: 'Log out',
    url: '/authentication/logout',
    color: main.colors.error,
    icon: 'Logout' as const,
  },
]
